module.exports = __webpack_public_path__ + "static/media/landingPageVideo1.4e5b1fd0.webp";